import { getLanguageFromPath } from 'helpers/i18n'

const language = getLanguageFromPath()
const domain = process.env.REACT_APP_HOME_URL || 'https://parkofpoland.com/'

const links = {
    home: {
        pl: `${domain}pl`,
        en: `${domain}en`,
        uk: `${domain}uk`,
    },
    openingHours: {
        pl: `${domain}pl/informacje#godziny-otwarcia`,
        en: `${domain}en/information#opening-hours`,
        uk: `${domain}uk/information#години-роботи`,
    },
    login: {
        pl: `${domain}pl/konto/logowanie`,
        en: `${domain}en/account/login`,
        uk: `${domain}uk/account/login`,
    },
    signup: {
        pl: `${domain}pl/konto/rejestracja`,
        en: `${domain}en/account/register`,
        uk: `${domain}uk/account/register`,
    },
    suntagoOnlineTicketSalesRegulations: {
        pl: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf`,
        en: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf`,
        uk: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf`,
    },
    suntagoOnlineTicketSalesRegulationsChangesPage: {
        pl: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf#page=7`,
        en: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf#page=7`,
        uk: `${domain}docs/suntago_regulamin_sprzedazy_online_biletow_wstepu_i_uslug_2025.pdf#page=7`,
    },
    generalRegulationsOfSuntagoWaterWorld: {
        pl: `${domain}docs/General_regulations_of_Suntago_Water_World_PL.pdf`,
        en: `${domain}docs/General_regulations_of_Suntago_Water_World_ENG.pdf`,
        uk: `${domain}docs/General_regulations_of_Suntago_Water_World_UA.pdf`,
    },
    suntagoVillageReservationRegulations: {
        pl: `${domain}docs/Regulamin_sprzedazy_Suntago_Village.pdf`,
        en: `${domain}docs/Sales_regulations_Suntago_Village.pdf`,
        uk: `${domain}docs/Regulamin_sprzedazy_Suntago_Village.pdf`,
    },
    suntagoVillageStayRegulations: {
        pl: `${domain}docs/Suntago_Village_Stay_Regulations_PL.pdf`,
        en: `${domain}docs/Suntago_Village_Stay_Regulations_EN.pdf`,
        uk: `${domain}docs/Suntago_Village_Stay_Regulations_PL.pdf`,
    },
    privacyPolicy: {
        pl: `${domain}docs/Polityka_prywatnosci.pdf`,
        en: `${domain}docs/privacy_policy.pdf`,
        uk: `${domain}docs/Polityka_prywatnosci.pdf`,
    },
    timetableZyrardow: {
        pl: `${domain}pl/rozklad-jazdy#zyrardow`,
        en: `${domain}en/timetable#zyrardow`,
        uk: `${domain}uk/timetable#zyrardow`,
    },
    accommodation: {
        pl: `${domain}pl/zakwaterowanie`,
        en: `${domain}en/accommodation`,
        uk: `${domain}uk/accommodation`,
    },
    accommodationReservationSection: {
        pl: `${domain}pl/zakwaterowanie#zarezerwuj-bungalow`,
        en: `${domain}en/accommodation#book-bungalow`,
        uk: `${domain}uk/accommodation#бронювання-бунгало`,
    },
    restaurants: {
        pl: `${domain}pl/atrakcje/restauracje`,
        en: `${domain}en/attractions/restaurants`,
        uk: `${domain}uk/attractions/restaurants`,
    },
    cityBreak: {
        pl: `${domain}pl/city-break`,
        en: `${domain}en/city-break`,
        uk: `${domain}uk/city-break`,
    },
    faq: {
        pl: `${domain}pl/faq`,
        en: `${domain}en/faq`,
        uk: `${domain}uk/faq`,
    },
    contact: {
        pl: `${domain}pl/kontakt`,
        en: `${domain}en/contact`,
        uk: `${domain}uk/contact`,
    },
    rodo: {
        pl: `${domain}docs/RODO_PL.pdf`,
        en: `${domain}docs/RODO_EN.pdf`,
        uk: `${domain}docs/RODO_PL.pdf`,
    },
    voucher: {
        pl: `${domain}docs/Regulamin_zakupu_i_korzystania_z_voucherow.pdf`,
        en: `${domain}docs/Regulations_of_purchase_and_use_of_the_Vouchers.pdf`,
        uk: `${domain}docs/Regulamin_zakupu_i_korzystania_z_voucherow_UA.pdf`,
    },
    cardRegulations: {
        pl: `${domain}docs/Regulamin_Kart_Rocznych_Suntago.pdf`,
        en: `${domain}docs/Suntago_Unlimited_Card_regulations.pdf`,
        uk: `${domain}docs/Regulamin_Kart_Rocznych_Suntago_UA.pdf`,
    },
    benefits: {
        pl: `${domain}pl/info/karta-caloroczna#korzysci`,
        en: `${domain}en/info/unlimited-card#benefits`,
        uk: `${domain}uk/info/unlimited-card#переваги`,
    },
    attractions: {
        pl: `${domain}pl/atrakcje`,
        en: `${domain}en/attractions`,
        uk: `${domain}uk/attractions`,
    },
    blackWeekendRegulations: {
        pl: `${domain}docs/Zasady_promocji_Black_Weekend_2024.pdf`,
        en: `${domain}docs/Black_Weekend_promo_regulations_2024.pdf`,
        uk: `${domain}docs/Zasady_promocji_Black_Weekend_2024.pdf`,
    },
    cityBreakRegulations: {
        pl: `${domain}docs/regulamin_city_break_2025.pdf`,
        en: `${domain}docs/city_break_2025_promotion_regulations.pdf`,
        uk: `${domain}docs/regulamin_city_break_2025_ua.pdf`,
    },
    marchPromotionLandingPage: {
        pl: `${domain}pl/march-promo`,
        en: `${domain}en/march-promo`,
        uk: `${domain}uk/march-promo`,
    },
    marchPromotionRegulations: {
        pl: `${domain}docs/regulamin_promocji_march_promo_2025.pdf`,
        en: `${domain}docs/march_promo_regulations_2025.pdf`,
        uk: `${domain}docs/regulamin_promocji_march_promo_2025_ua.pdf`,
    },
    augustPromotionLandingPage: {
        pl: `${domain}pl/50-na-druga-wizyte`,
        en: `${domain}en/50-for-second-visit`,
        uk: `${domain}uk/50-for-second-visit`,
    },
    birthdayPromotionRegulations: {
        pl: `${domain}docs/regulamin_promocji_5_urodziny_suntago.pdf`,
        en: `${domain}docs/5_birthday_promotion_regulations.pdf`,
        uk: `${domain}docs/regulamin_promocji_5_urodziny_suntago_ua.pdf`,
    },
    christmasVibesSchedule: {
        pl: `${domain}docs/harmonogram_swiatecznych_atrakcji_2023_PL.pdf`,
        en: `${domain}docs/harmonogram_swiatecznych_atrakcji_2023_EN.pdf`,
        uk: `${domain}docs/harmonogram_swiatecznych_atrakcji_2023_PL.pdf`,
    },
    winterBreakAttractionsSchedule: {
        pl: `${domain}docs/harmonogram_zimowych_atrakcji_2024.pdf`,
        en: `${domain}docs/winter_attractions_schedule_2024.pdf`,
        uk: `${domain}docs/harmonogram_zimowych_atrakcji_2024.pdf`,
    },
    vipZoneRegulations: {
        pl: `${domain}docs/Suntago_Regulamin_Strefy_VIP_zakres_pakietu_VIP_i_zasady_korzystania.pdf`,
        en: `${domain}docs/Suntago_Regulations_VIP_Zone_scope_of_VIP_service_terms_of_use.pdf`,
        uk: `${domain}docs/Suntago_Regulamin_Strefy_VIP_zakres_pakietu_VIP_i_zasady_korzystania_UA.pdf`,
    },
    unlimitedLandingPage: {
        pl: `${domain}pl/info/karta-caloroczna`,
        en: `${domain}en/info/unlimited-card`,
        uk: `${domain}uk/info/unlimited-card`,
    },
    vouchersLandingPage: {
        pl: `${domain}pl/vouchery#karta`,
        en: `${domain}en/vouchers#card`,
        uk: `${domain}uk/vouchers#картка`,
    },
    backToSchoolRegulations: {
        pl: `${domain}docs/Suntago_Back_to_School_Zasady_promocji.pdf`,
        en: `${domain}docs/Suntago_Back_to_School_Promo_rules.pdf`,
        uk: `${domain}docs/Suntago_Back_to_School_Zasady_promocji.pdf`,
    },
    unlimited1stRenewRegulations: {
        pl: `${domain}docs/Specjalna_oferta_dla_uzytkownikow_Unlimited.pdf`,
        en: `${domain}docs/Special_Offer_for_Unlimited_cardholders.pdf`,
        uk: `${domain}docs/Specjalna_oferta_dla_uzytkownikow_Unlimited.pdf`,
    },
    unlimited2ndRenewRegulations: {
        pl: `${domain}docs/Specjalna_oferta_dla_uzytkownikow_Unlimited_Blue.pdf`,
        en: `${domain}docs/Special_Offer_for_Unlimited_Blue_cardholders.pdf`,
        uk: `${domain}docs/Specjalna_oferta_dla_uzytkownikow_Unlimited_Blue.pdf`,
    },
    unlimitedRenewUsageRegulations: {
        pl: `${domain}docs/Zasady_korzystania_z_voucherow_specjalnych_Nowa_Karta_Suntago.pdf`,
        en: `${domain}docs/Rules_for_using_special_vouchers_New_Suntago_Annual_Cards.pdf`,
        uk: `${domain}docs/Zasady_korzystania_z_voucherow_specjalnych_Nowa_Karta_Suntago.pdf`,
    },
    maintenancePage: {
        pl: `${domain}pl/konserwacja-atrakcji`,
        en: `${domain}en/attraction-maintenance`,
        uk: `${domain}uk/attraction-maintenance`,
    },
    howtoGetPage: {
        pl: `${domain}pl/jak-sie-dostac`,
        en: `${domain}en/how-to-get`,
        uk: `${domain}uk/how-to-get`,
    },
    pricingPage: {
        pl: `${domain}pl/cennik`,
        en: `${domain}en/pricing`,
        uk: `${domain}uk/pricing`,
    },
    familyPackageRegulations: {
        pl: `${domain}docs/Specjalne_warunki_zakupu_Pakietu_Rodzinnego.pdf`,
        en: `${domain}docs/Special_conditions_for_the_purchase_of_Family_Package.pdf`,
        uk: `${domain}docs/Specjalne_warunki_zakupu_Pakietu_Rodzinnego.pdf`,
    },
    mayPromoStudentsRegulations: {
        pl: `${domain}docs/Suntago_Regulamin_Promocji_dla_mlodych_do_26_roku_zycia.pdf`,
        en: `${domain}docs/Suntago_Promotions_rules_for_young_people_under_26_years_of_age.pdf`,
        uk: `${domain}docs/Suntago_Regulamin_Promocji_dla_mlodych_do_26_roku_zycia.pdf`,
    },
    mayPromoWeekendsRegulations: {
        pl: `${domain}docs/Suntago_Zasady_promocji_Majowe_Weekendy.pdf`,
        en: `${domain}docs/Suntago_May_Weekend_promotion_regulations.pdf`,
        uk: `${domain}docs/Suntago_Zasady_promocji_Majowe_Weekendy.pdf`,
    },
    sv79PromoRegulations: {
        pl: `${domain}docs/zasady_promocji_Dwie_noce_w_tropikach.pdf`,
        en: `${domain}docs/Two_tropical_nights_promotion_regulations.pdf`,
        uk: `${domain}docs/zasady_promocji_Dwie_noce_w_tropikach.pdf`,
    },
    studentPromo2024Regulations: {
        pl: `${domain}docs/Suntago_Regulamin_Jesien_Dla_Mlodych_09_2024.pdf`,
        en: `${domain}docs/Suntago_Regulamin_Jesien_Dla_Mlodych_09_2024_ENG.pdf`,
        uk: `${domain}docs/Suntago_Regulamin_Jesien_Dla_Mlodych_09_2024.pdf`,
    },
    seniorPackageRegulations: {
        pl: `${domain}docs/Suntago_Zasady_promocji_Pakiet_dla_Seniora.pdf`,
        en: `${domain}docs/Suntago_Package_for_Seniors_promotion_regulations.pdf`,
        uk: `${domain}docs/Suntago_Zasady_promocji_Pakiet_dla_Seniora.pdf`,
    },
    summerSaleRegulations: {
        pl: `${domain}docs/Zasady_promocji_Letnia_Wyprzedaz_2024.pdf`,
        en: `${domain}docs/Summer_Sale_promo_regulations_2024.pdf`,
        uk: `${domain}docs/Zasady_promocji_Letnia_Wyprzedaz_2024.pdf`,
    },
    earlyPurchaseRegulations: {
        pl: `${domain}docs/regulamin_promocji_Online_taniej_10_20.pdf`,
        en: `${domain}docs/Online_cheaper_10_20_promotion_regulations.pdf`,
        uk: `${domain}docs/regulamin_promocji_Online_taniej_10_20.pdf`,
    },
    spaContraindicationsDoc: {
        pl: `${domain}docs/spa_przeciwwskazania_lista.pdf`,
        en: `${domain}docs/spa_contraindications_list.pdf`,
        uk: `${domain}docs/contraindications_ua.pdf`,
    },
    spaContraindicationsStatement: {
        pl: `${domain}docs/spa_oswiadczenie_o_przeciwwskazaniach.pdf`,
        en: `${domain}docs/spa_contraindications_statement.pdf`,
        uk: `${domain}docs/spa_declaration_of_no_contraindications_ua.pdf`,
    },
    facebook: {
        pl: 'https://www.facebook.com/parkofpoland',
        en: 'https://www.facebook.com/parkofpoland',
        uk: 'https://www.facebook.com/parkofpoland',
    },
    youtube: {
        pl: 'https://www.youtube.com/c/ParkofPoland',
        en: 'https://www.youtube.com/c/ParkofPoland',
        uk: 'https://www.youtube.com/c/ParkofPoland',
    },
    instagram: {
        pl: 'https://www.instagram.com/parkofpoland/',
        en: 'https://www.instagram.com/parkofpoland/',
        uk: 'https://www.instagram.com/parkofpoland/',
    },
}

export const HOME_LINK = links.home[language]

export const OPENING_HOURS_LINK = links.openingHours[language]

export const LOGIN_LINK = links.login[language]
export const SIGNUP_LINK = links.signup[language]

export const SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK =
    links.suntagoOnlineTicketSalesRegulations[language]
export const SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK_CHANGES_PAGE =
    links.suntagoOnlineTicketSalesRegulationsChangesPage[language]

export const GENERAL_REGULATIONS_OF_SUNTAGO_WATER_WORLD_LINK =
    links.generalRegulationsOfSuntagoWaterWorld[language]

export const SUNTAGO_VILLAGE_RESERVATION_REGULATIONS_LINK =
    links.suntagoVillageReservationRegulations[language]

export const SUNTAGO_VILLAGE_STAY_REGULATIONS_LINK =
    links.suntagoVillageStayRegulations[language]

export const PRIVACY_POLICY_LINK = links.privacyPolicy[language]

export const TIMETABLE_ZYRARDOW_LINK = links.timetableZyrardow[language]

export const ACCOMMODATION_LINK = links.accommodation[language]

export const ACCOMMODATION_RESERVATION_SECTION_LINK =
    links.accommodationReservationSection[language]

export const RESTAURANTS_LINK = links.restaurants[language]

export const FAQ_LINK = links.faq[language]

export const CONTACT_LINK = links.contact[language]

export const RODO_LINK = links.rodo[language]

export const VOUCHER_LINK = links.voucher[language]

export const CARD_REGULATIONS_LINK = links.cardRegulations[language]

export const BENEFITS_LINK = links.benefits[language]

export const ATTRACTIONS_LINK = links.attractions[language]

export const BLACK_WEEKEND_REGULATIONS_LINK =
    links.blackWeekendRegulations[language]

export const MARCH_PROMOTION_LANDING_PAGE_LINK =
    links.marchPromotionLandingPage[language]

export const MARCH_PROMOTION_REGULATIONS_LINK =
    links.marchPromotionRegulations[language]

export const AUGUST_PROMOTION_LANDING_PAGE_LINK =
    links.augustPromotionLandingPage[language]

export const BIRTHDAY_PROMOTION_REGULATIONS_LINK =
    links.birthdayPromotionRegulations[language]

export const CITY_BREAK_PROMOTION_REGULATIONS_LINK =
    links.cityBreakRegulations[language]

export const CHRISTMAS_VIBES_SCHEDULE_LINK =
    links.christmasVibesSchedule[language]

export const WINTER_BREAK_ATTRACTIONS_SCHEDULE_LINK =
    links.winterBreakAttractionsSchedule[language]

export const VIP_ZONE_REGULATIONS = links.vipZoneRegulations[language]

export const UNLIMITED_LANDING_PAGE = links.unlimitedLandingPage[language]

export const CITY_BREAK_LANDING_PAGE = links.cityBreak[language]

export const VOUCHERS_LANDING_PAGE = links.vouchersLandingPage[language]

export const BACK_TO_SCHOOL_REGULATIONS_LINK =
    links.backToSchoolRegulations[language]

export const UNLIMITED_1ST_RENEW_REGULATIONS_LINK =
    links.unlimited1stRenewRegulations[language]

export const UNLIMITED_2ND_RENEW_REGULATIONS_LINK =
    links.unlimited2ndRenewRegulations[language]

export const UNLIMITED_RENEW_USAGE_REGULATIONS_LINK =
    links.unlimitedRenewUsageRegulations[language]

export const MAINTENANCE_PAGE_LINK = links.maintenancePage[language]

export const HOWTO_GET_LINK = links.howtoGetPage[language]

export const PRICING_LINK = links.pricingPage[language]

export const FACEBOOK_LINK = links.facebook[language]

export const INSTAGRAM_LINK = links.instagram[language]

export const YOUTUBE_LINK = links.youtube[language]

export const FAMILY_PACKAGE_REGULATIONS_LINK =
    links.familyPackageRegulations[language]

export const MAY_PROMO_STUDENTS_REGULATIONS_LINK =
    links.mayPromoStudentsRegulations[language]

export const MAY_PROMO_WEEKENDS_REGULATIONS_LINK =
    links.mayPromoWeekendsRegulations[language]

export const SV_79_PROMO_REGULATIONS_LINK = links.sv79PromoRegulations[language]

export const STUDENT_PROMO_2024_REGULATIONS_LINK =
    links.studentPromo2024Regulations[language]

export const SENIOR_PACKAGE_REGULATIONS_LINK =
    links.seniorPackageRegulations[language]

export const SUMMER_SALE_REGULATIONS_LINK =
    links.summerSaleRegulations[language]

export const EARLY_PURCHASE_REGULATIONS_LINK =
    links.earlyPurchaseRegulations[language]

export const SPA_CONTRAINDICATIONS_DOC = links.spaContraindicationsDoc[language]
export const SPA_CONTRAINDICATIONS_STATEMENT =
    links.spaContraindicationsStatement[language]
